<template>
  <div class="box-card">
    <div class="card-header">
      <span>选择付款方式</span>
    </div>
    <div class="box-content">
      <el-radio-group v-model="subPayType" @change="changePayType">
        <el-radio label="1" border>微信支付</el-radio>
        <el-radio label="2" border>支付宝</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: ["payType"],
  data() {
    return {
      subPayType:this.payType
    };
  },
  methods: {
    changePayType(value) {
      this.$emit("changePayType", value);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.box-card {
  width: 3.65rem;
  margin: 0.05rem auto 0.05rem;
  box-shadow: #efefef 0 0 0.5rem;
  border: solid #efefef 1px;
  background: #fff;
  border-radius: 0.05rem;
  position: relative;
}
.card-header {
  padding: 0.15rem 0.175rem;
  border-bottom: solid #efefef 1px;
}
.box-content {
  position: relative;
  padding: 0.175rem 0.1rem;
  display: flex;
  flex-wrap: wrap;
}
</style>
